var _rect, _path, _path2, _rect2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedExpertBacked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    rx: 15,
    fill: "url(#paint0_linear_329_88)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0007 44C45.444 44 50.6673 38.7766 50.6673 32.3333C50.6673 25.89 45.444 20.6666 39.0007 20.6666C32.5573 20.6666 27.334 25.89 27.334 32.3333C27.334 38.7766 32.5573 44 39.0007 44Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6827 42.15L30.666 57.3333L38.9993 52.3333L47.3327 57.3333L45.316 42.1333",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    rx: 15,
    fill: "url(#paint1_linear_329_88)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0007 44C45.444 44 50.6673 38.7766 50.6673 32.3333C50.6673 25.89 45.444 20.6666 39.0007 20.6666C32.5573 20.6666 27.334 25.89 27.334 32.3333C27.334 38.7766 32.5573 44 39.0007 44Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6827 42.15L30.666 57.3333L38.9993 52.3333L47.3327 57.3333L45.316 42.1333",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_88",
    x1: 5.5,
    y1: 5,
    x2: 71.5,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_329_88",
    x1: 5.5,
    y1: 5,
    x2: 71.5,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedExpertBacked);
export default __webpack_public_path__ + "static/media/VerifiedExpertBacked.fe7819d9a91f3d675e29baea8ca9e515.svg";
export { ForwardRef as ReactComponent };